import type { ParsedUrlQuery } from 'querystring'

const getQueryString = (q?: ParsedUrlQuery) => {
  if (!q) {
    return ''
  }
  let query = '?'
  Object.keys(q).forEach((key) => {
    query += `${query !== '?' ? '&' : ''}${key}=${q[key]}`
  })
  return query !== '?' ? query : ''
}

export default getQueryString
